/* eslint-disable camelcase */
import { ResponseMessageUser } from '@/types/internalChatAxios'

export const isComponents = {
  audio: 'MessageAudio',
  button: 'MessageText',
  file: 'MessageFile',
  image: 'MessageImage',
  text: 'MessageText',
  video: 'MessageVideo',
  system: 'MessageDivider',
  started: 'MessageDivider',
  closed: 'MessageDivider',
  none: ''
} as const

export type KeysReplyContentType = keyof typeof isComponents

export type ValuesReplyContentType = (typeof isComponents)[KeysReplyContentType] | 'none'

type Button = {
  text: string
  action: string
}
export type ReplyContent = {
  message: string
  content?: string
  type: KeysReplyContentType
}

export type Reply = {
  content: ReplyContent
  message_id: string
  type: string
}
export type MessageType = 'received' | 'sent' | 'system'

export interface Message {
  id: string
  reply?: Reply
  legend: string | null
  type: string
  position: MessageType
  message: string
  content?: string
  file?: string
  buttons?: Button[]
  user?: string
  photo?: string | null
  date: string
}

type ContentButton = {
  text: string
}

export type ContentType = 'text' | 'image' | 'video' | 'audio' | 'file' | 'document' | 'none'

export type MessageContent = {
    type: KeysReplyContentType
    message: string
    content?: string
    legend?: string
    buttons?: ContentButton[]
    by_user?: string
    position?: MessageType
  }

export interface MessageChat {
  id: number
  uuid: string
  type: MessageType | string
  origin: string
  device: 'webchat' | 'web' | 'app' | string
  content: MessageContent
  ack: number
  timestamp: string | number
  api_key?: string | undefined
  reply?: Reply | undefined
  status: 'pending' | 'sent' | 'received'
}

export type PreviewFile = {
    id: number,
    type: ContentType,
    url: string,
    name: string,
    size: string,
    legend?: string,
    origin?:string
    recipient?: 'sent' | 'received'
}

export type KeysUsersInternalChat = {
    [key: number] : ResponseMessageUser
  }
export interface RootStateMessage {
    users: KeysUsersInternalChat;
    groups: KeysUsersInternalChat;
}

export type KeysRootStateMessage = keyof RootStateMessage
